import { createStorage, STORE_STORAGE_KEYS } from "@ecommerce/shared-utils";

const storage = createStorage({
    userStorageKey: STORE_STORAGE_KEYS.user,
    tokenStorageKey: STORE_STORAGE_KEYS.tokens,
});

export const {
    userStorage,
    authTokenStorage,
    clearAuthSession,
    getAccessToken,
    getRefreshToken,
    saveAuthTokens,
} = storage;
